exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "scroll-top {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  cursor: pointer;\n  color: #000;\n  bottom: 1.5rem;\n  margin-right: 1rem; }\n  scroll-top .hide {\n    display: none; }\n  scroll-top > div {\n    background-color: #fff;\n    padding: .25rem; }\n", ""]);

// exports
